// admin/src/services/profile.js
import api from './api';
import { API_ENDPOINTS } from '../config/api';

export const profileService = {
  // Get admin profile - fix endpoint
  getProfile: async () => {
    const response = await api.get(API_ENDPOINTS.auth.profile);
    return response.data;
  },

  // Update profile - fix endpoint
  updateProfile: async (data) => {
    const response = await api.patch(API_ENDPOINTS.auth.profile, data);
    return response.data;
  },

  // Change password - fix endpoint
  changePassword: async (data) => {
    const response = await api.patch(`${API_ENDPOINTS.auth.profile}/password`, data);
    return response.data;
  }
};